export default {
    listagem: {
        titulo_pagina: 'List of Materials',
        novo: 'Create New Material',
        habilitado: 'Able',
        desabilitado: 'Disabled',
        table: {
            empty: 'No Material Found',
            nome: 'Name',
            codigo: 'Code',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Material',
            editar: 'Edit Material'
        },
        fields: {
            codigo: {
                label: 'Code',
                description: 'Material Code'
            },
            nome: {
                label: 'Name',
                description: 'Material Name'
            },
            status: {
                label: 'Status',
                description: 'Active or inactive status of the Material'
            },
            botao_salvar : 'Save Material'
        },
        create: {
            success: 'Material created successfully!',
            error: 'Error creating material!'
        },
        update: {
            success: 'Material successfully edited!',
            error: 'Error editing material!'
        }
    }
}
